<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      floating
      app
    >
      <v-list-item two-line>
        <v-progress-linear
          v-if="!!!user"
          indeterminate
          rounded
        ></v-progress-linear>
        <v-list-item-content v-else>
          <v-list-item-title class="text-h6">{{
            user.username
          }}</v-list-item-title>
          <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list nav>
        <v-list-item-group color="primary">
          <v-list-item :to="{ name: 'home' }" exact>
            <v-list-item-icon>
              <v-icon>mdi-home</v-icon>
            </v-list-item-icon>

            <v-list-item-title>{{
              $t('NAVIGATION.DASHBOARD')
            }}</v-list-item-title>
          </v-list-item>

          <v-list-item :to="{ name: 'persons' }">
            <v-list-item-icon>
              <v-icon>mdi-account-group</v-icon>
            </v-list-item-icon>

            <v-list-item-title>{{
              $t('NAVIGATION.PERSONS')
            }}</v-list-item-title>
          </v-list-item>

          <v-list-item :to="{ name: 'companies' }">
            <v-list-item-icon>
              <v-icon>mdi-briefcase</v-icon>
            </v-list-item-icon>

            <v-list-item-title>{{
              $t('NAVIGATION.COMPANIES')
            }}</v-list-item-title>
          </v-list-item>

          <v-list-item :to="{ name: 'building_complexes' }">
            <v-list-item-icon>
              <v-icon>mdi-city-variant</v-icon>
            </v-list-item-icon>

            <v-list-item-title>
              {{ $t('NAVIGATION.BUILDING_COMPLEXES') }}
            </v-list-item-title>
            <v-spacer />
            <v-btn
              icon
              small
              @click.native.prevent="
                groupOpened.buildingComplexes = !groupOpened.buildingComplexes
              "
            >
              <v-icon>{{
                groupOpened.buildingComplexes
                  ? 'mdi-chevron-up'
                  : 'mdi-chevron-down'
              }}</v-icon>
            </v-btn>
          </v-list-item>

          <v-expand-transition>
            <div v-if="groupOpened.buildingComplexes">
              <v-list-item class="pl-16" :to="{ name: 'buildings' }">
                <v-list-item-icon>
                  <v-icon>mdi-home-city</v-icon>
                </v-list-item-icon>

                <v-list-item-title>{{
                  $t('NAVIGATION.BUILDINGS')
                }}</v-list-item-title>
              </v-list-item>

              <v-list-item
                class="pl-16"
                :to="{ name: 'building-complexes-contracts' }"
              >
                <v-list-item-icon>
                  <v-icon>mdi-script-text-outline</v-icon>
                </v-list-item-icon>

                <v-list-item-title>
                  {{ $t('NAVIGATION.CONTRACTS') }}
                </v-list-item-title>
              </v-list-item>
            </div>
          </v-expand-transition>

          <v-list-item :to="{ name: 'services' }">
            <v-list-item-icon>
              <v-icon>mdi-room-service</v-icon>
            </v-list-item-icon>

            <v-list-item-title>{{
              $t('NAVIGATION.SERVICES')
            }}</v-list-item-title>
          </v-list-item>

          <v-list-group prepend-icon="mdi-book-open-outline" no-action>
            <template v-slot:activator>
              <v-list-item-title>
                <booking-badge :text="$t('NAVIGATION.BOOKING')"></booking-badge
              ></v-list-item-title>
            </template>

            <v-list-item :to="{ name: 'booking-resources' }">
              <v-list-item-icon>
                <v-icon>mdi-book-clock-outline</v-icon>
              </v-list-item-icon>

              <v-list-item-title>{{
                $t('NAVIGATION.BOOKING_RESOURCE')
              }}</v-list-item-title>
            </v-list-item>

            <v-list-item :to="{ name: 'booking-reservations' }">
              <v-list-item-icon>
                <v-icon>mdi-tablet-android</v-icon>
              </v-list-item-icon>

              <v-list-item-title>
                {{ $t('NAVIGATION.BOOKING_RESERVATIONS') }}
              </v-list-item-title>

              <v-list-item-action-text>
                <reservations-new-status-chip />
              </v-list-item-action-text>
            </v-list-item>

            <v-list-item :to="{ name: 'booking-schedule' }">
              <v-list-item-icon>
                <v-icon>mdi-timetable</v-icon>
              </v-list-item-icon>

              <v-list-item-title>{{
                $t('NAVIGATION.BOOKING_SCHEDULE')
              }}</v-list-item-title>
            </v-list-item>
          </v-list-group>

          <v-list-item :to="{ name: 'orders' }">
            <v-list-item-icon>
              <v-icon>mdi-clipboard-edit-outline</v-icon>
            </v-list-item-icon>

            <v-list-item-title>
              <orders-opened-badge
                :text="$t('NAVIGATION.ORDERS')"
              ></orders-opened-badge
            ></v-list-item-title>
          </v-list-item>

          <v-list-group prepend-icon="mdi-text-box-multiple-outline" no-action>
            <template v-slot:activator>
              <v-list-item-title>
                <ereporter-badge :text="$t('NAVIGATION.EREPORTER')" />
              </v-list-item-title>
            </template>

            <v-list-item :to="{ name: 'plannings' }">
              <v-list-item-icon>
                <v-icon>mdi-notebook-outline</v-icon>
              </v-list-item-icon>

              <v-list-item-title>{{
                $t('NAVIGATION.PLANNING')
              }}</v-list-item-title>
            </v-list-item>

            <v-list-item :to="{ name: 'employees' }">
              <v-list-item-icon>
                <v-icon>mdi-account-clock</v-icon>
              </v-list-item-icon>

              <v-list-item-title>{{
                $t('NAVIGATION.EMPLOYEES')
              }}</v-list-item-title>
            </v-list-item>

            <v-list-item :to="{ name: 'request-vacations' }">
              <v-list-item-icon>
                <v-icon>mdi-wallet-travel</v-icon>
              </v-list-item-icon>

              <v-list-item-title>{{
                $t('NAVIGATION.REQUEST_VACATIONS')
              }}</v-list-item-title>

              <v-list-item-action-text>
                <request-vacation-badge />
              </v-list-item-action-text>
            </v-list-item>

            <v-list-item :to="{ name: 'tasks' }">
              <v-list-item-icon>
                <v-icon>mdi-calendar-check</v-icon>
              </v-list-item-icon>

              <v-list-item-title>{{
                $t('NAVIGATION.TASKS')
              }}</v-list-item-title>
            </v-list-item>

            <v-list-item :to="{ name: 'invoices' }">
              <v-list-item-icon>
                <v-icon>mdi-receipt</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>
                  {{ $t('NAVIGATION.INVOICES') }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{ name: 'payrolls' }">
              <v-list-item-icon>
                <v-icon>mdi-credit-card-settings-outline</v-icon>
              </v-list-item-icon>

              <v-list-item-title>
                {{ $t('NAVIGATION.PAYROLLS') }}
              </v-list-item-title>
            </v-list-item>

            <v-list-item :to="{ name: 'expenses' }">
              <v-list-item-icon>
                <v-icon>mdi-currency-usd</v-icon>
              </v-list-item-icon>

              <v-list-item-title>
                {{ $t('NAVIGATION.EXPENSES') }}
              </v-list-item-title>
            </v-list-item>
          </v-list-group>

          <v-list-group prepend-icon="mdi-medical-bag" no-action>
            <template v-slot:activator>
              <v-list-item-title>
                {{ $t('NAVIGATION.MEDICALL') }}
              </v-list-item-title>
            </template>

            <v-list-item
              v-if="$can('sensitive-data')"
              :to="{ name: 'subscriptions' }"
            >
              <v-list-item-icon>
                <v-icon>mdi-calendar-clock</v-icon>
              </v-list-item-icon>

              <v-list-item-title>{{
                $t('NAVIGATION.SUBSCRIPTIONS')
              }}</v-list-item-title>
            </v-list-item>

            <v-list-item
              v-if="$can('sensitive-data')"
              :to="{ name: 'devices' }"
            >
              <v-list-item-icon>
                <v-icon>mdi-tablet-android</v-icon>
              </v-list-item-icon>

              <v-list-item-title>
                {{ $t('NAVIGATION.DEVICES') }}
              </v-list-item-title>
            </v-list-item>

            <v-list-item :to="{ name: 'warehouse' }">
              <v-list-item-icon>
                <v-icon>mdi-warehouse</v-icon>
              </v-list-item-icon>

              <v-list-item-title>
                {{ $t('NAVIGATION.WAREHOUSE') }}
              </v-list-item-title>
            </v-list-item>
          </v-list-group>

          <v-list-group prepend-icon="mdi-folder-outline" no-action>
            <template v-slot:activator>
              <v-list-item-title>
                {{ $t('NAVIGATION.DOCUMENTS') }}
              </v-list-item-title>
            </template>

            <v-list-item :to="{ name: 'documents' }">
              <v-list-item-icon>
                <v-icon>mdi-file-document-outline</v-icon>
              </v-list-item-icon>

              <v-list-item-title>{{ $t('ITEM.FILES') }}</v-list-item-title>
            </v-list-item>

            <v-list-item :to="{ name: 'documents-links' }">
              <v-list-item-icon>
                <v-icon>mdi-file-link-outline</v-icon>
              </v-list-item-icon>

              <v-list-item-title>
                {{ $t('NAVIGATION.LINKS') }}
              </v-list-item-title>
            </v-list-item>

            <v-list-item :to="{ name: 'documents-lists' }">
              <v-list-item-icon>
                <v-icon>mdi-file-table-outline</v-icon>
              </v-list-item-icon>

              <v-list-item-title>
                {{ $t('NAVIGATION.LISTS') }}
              </v-list-item-title>
            </v-list-item>
          </v-list-group>

          <v-list-item :to="{ name: 'posts' }">
            <v-list-item-icon>
              <v-icon>mdi-bulletin-board</v-icon>
            </v-list-item-icon>

            <v-list-item-title>{{ $t('NAVIGATION.POSTS') }}</v-list-item-title>
          </v-list-item>

          <v-list-item :to="{ name: 'reports' }">
            <v-list-item-icon>
              <v-icon>mdi-folder-multiple</v-icon>
            </v-list-item-icon>

            <v-list-item-title>{{
              $t('NAVIGATION.REPORTS')
            }}</v-list-item-title>
          </v-list-item>

          <v-list-item :to="{ name: 'notifications' }">
            <v-list-item-icon>
              <v-icon>mdi-bell</v-icon>
            </v-list-item-icon>

            <v-list-item-title>{{
              $t('NAVIGATION.NOTIFICATIONS')
            }}</v-list-item-title>
          </v-list-item>

          <v-list-item :to="{ name: 'inhabitant-changes' }">
            <v-list-item-icon>
              <v-icon>mdi-account-group</v-icon>
            </v-list-item-icon>

            <v-list-item-title>
              <inhabitant-change-badge
                :text="$t('NAVIGATION.INHABITANT_CHANGES')"
              ></inhabitant-change-badge
            ></v-list-item-title>
          </v-list-item>

          <v-list-group prepend-icon="mdi-cog-outline" no-action>
            <template v-slot:activator>
              <v-list-item-title>{{
                $t('NAVIGATION.SETTINGS')
              }}</v-list-item-title>
            </template>

            <v-list-group no-action sub-group>
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>{{
                    $t('NAVIGATION.MANAGE_USERS')
                  }}</v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item :to="{ name: 'users' }">
                <v-list-item-action>
                  <v-icon>mdi-account-multiple</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{
                    $t('NAVIGATION.USERS')
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>

            <v-list-group no-action sub-group>
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>{{
                    $t('NAVIGATION.MANAGE_APP_LAYOUTS')
                  }}</v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item :to="{ name: 'app-layouts' }">
                <v-list-item-action>
                  <v-icon>mdi-animation-play-outline</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{
                    $t('NAVIGATION.APP_LAYOUTS')
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>

            <v-list-item :to="{ name: 'personal-inerests' }">
              <v-list-item-content>
                <v-list-item-title>{{
                  $t('NAVIGATION.PERSONAL_INTERESTS')
                }}</v-list-item-title>
              </v-list-item-content> </v-list-item
            ><v-list-item :to="{ name: 'forms' }">
              <v-list-item-content>
                <v-list-item-title>{{
                  $t('NAVIGATION.FORMS')
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'communication-options' }">
              <v-list-item-content>
                <v-list-item-title>{{
                  $t('NAVIGATION.COMMUNICATION_OPTIONS')
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'abo-services' }">
              <v-list-item-content>
                <v-list-item-title>{{
                  $t('NAVIGATION.ABO')
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'holidays' }">
              <v-list-item-content>
                <v-list-item-title>{{
                  $t('NAVIGATION.HOLIDAYS')
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

          <v-list-group prepend-icon="mdi-cellphone-text" no-action>
            <template v-slot:activator>
              <v-list-item-title>{{ $t('NAVIGATION.APP') }}</v-list-item-title>
            </template>
            <v-list-item :to="{ name: 'appcontent' }">
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t('NAVIGATION.APP_CONTENT') }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{ name: 'apps' }">
              <v-list-item-title>
                {{ $t('NAVIGATION.APP_CONSTRUCTOR') }}
              </v-list-item-title>
            </v-list-item>
          </v-list-group>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      color="indigo"
      dark
      app
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

      <v-toolbar-title>
        <span
          v-if="domain === 'smpdev.bonacasa.ch'"
          class="text-h4 yellow--text"
        >
          [ DEV ]
        </span>
        <span
          v-else-if="domain !== 'smp.bonacasa.ch'"
          class="text-h4 error--text"
        >
          [ {{ domain }} ]
        </span>
        {{ $t('LABEL') }}
        <span class="primary--text">bonacasa</span>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <!--            <v-btn icon>-->
      <!--                <v-icon>mdi-heart</v-icon>-->
      <!--            </v-btn>-->

      <!--            <v-btn icon>-->
      <!--                <v-icon>mdi-magnify</v-icon>-->
      <!--            </v-btn>-->

      <!--            <v-menu offset-y>-->
      <!--                <template v-slot:activator="{ on }">-->
      <!--                    <v-btn icon v-on="on">-->
      <!--                        <v-icon>mdi-dots-vertical</v-icon>-->
      <!--                    </v-btn>-->
      <!--                </template>-->

      <!--                <v-list>-->
      <!--                    <v-list-item-->
      <!--                            v-for="n in 5"-->
      <!--                            :key="n"-->
      <!--                            @click=""-->
      <!--                    >-->
      <!--                        <v-list-item-title>Option {{ n }}</v-list-item-title>-->
      <!--                    </v-list-item>-->
      <!--                </v-list>-->
      <!--            </v-menu>-->

      <app-language />

      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn color="primary" fab small v-on="on">
            <v-icon>mdi-account</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            @click="$router.push({ name: 'logout' }).catch(error => {})"
          >
            <v-list-item-title>{{ $t('AUTH.LOGOUT') }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-main>
      <v-container fluid>
        <v-overlay color="white" :value="loading" z-index="1">
          <v-progress-circular
            :size="32"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </v-overlay>
        <!--        <v-overlay-->
        <!--                :value="loading"-->
        <!--                -->
        <!--        >-->
        <!--          <v-progress-circular indeterminate size="64"></v-progress-circular>-->
        <!--        </v-overlay>-->
        <router-view :key="$route.fullPath" />
      </v-container>
    </v-main>

    <v-footer color="indigo" app>
      <span class="white--text">&copy; {{ year }}</span>
    </v-footer>
  </div>
</template>

<script>
import AppLanguage from '@/modules/_global/_components/AppLanguage';
import { mapGetters } from 'vuex';
import OrdersOpenedBadge from '@/modules/orders_opened_badge/components/OrdersOpenedBadge.vue';
import ReservationsNewStatusChip from '@/modules/reservations_new_status_chip/components/ReservationsNewStatusChip.vue';
import BookingBadge from '@/modules/booking_badge/components/BookingBadge.vue';
import InhabitantChangeBadge from '@/modules/inhabitant_change_badge/components/InhabitantChangeBadge.vue';
import EreporterBadge from '@/modules/ereporter/components/EreporterBadge/EreporterBadge.vue';
import RequestVacationBadge from '@/modules/request_vacations/components/requestVacationBadge.vue';

export default {
  name: 'Layout',

  components: {
    RequestVacationBadge,
    EreporterBadge,
    AppLanguage,
    OrdersOpenedBadge,
    ReservationsNewStatusChip,
    BookingBadge,
    InhabitantChangeBadge
  },

  data: () => ({
    groupOpened: { buildingComplexes: false },
    drawer: true,
    domain: '',
    error: null,
    year: new Date().getFullYear()
  }),

  computed: {
    ...mapGetters({
      loading: 'loading'
    }),
    user() {
      return JSON.parse(this.$store.state.auth.user);
    }
  },

  created() {
    this.domain = document.location.hostname;
    document.title = 'SMP';
    document.title += ' - ' + document.location.hostname;
  }
};
</script>

<style scoped>
>>> .v-list-item__icon:first-child {
  margin-right: 16px;
}
>>> .v-list-group__header__prepend-icon {
  margin-right: 16px;
}
</style>
